import React from 'react';
import { Component } from 'react';

class PaitentWellcome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="welcome_message" /*style={styles.container}*/>
        <p>
          <b>Welcome to Greensun</b>
        </p>
        <br />
        <p>
          <b>In order to choose a clinic please continue at the app</b>
        </p>
      </div>
    );
  }
}

// const styles = {
//   container: {
//     display: "flex",
//     margin:"50%",
//     width:"50%",
//     flexDirection:"column",
//     alignItems:"center",
//     justifyContent: "center",
//     borderRadius:"5px",
//     border:"solid",
//     borderWidth:"1px"
//   },
// };

export default PaitentWellcome;
